import { Controller } from "@hotwired/stimulus"
import tippy from 'tippy.js'

// The picture a slide asks for exists only as words until somebody makes it, so
// the empty frame in the preview says what belongs there, and hands over the
// text, because whoever fills it is about to paste it somewhere else.
//
// The frame cannot be hovered directly: the layout draws the slide's text over
// the top of it, so the pointer never reaches the image. This watches the deck
// instead and shows the frame the pointer is actually over.
export default class extends Controller {
  static values = { briefs: Array }

  connect() {
    this.frames = []

    this.slides().forEach((slide, index) => {
      const brief = this.briefsValue[index]
      if (!brief) return

      slide.querySelectorAll('img[src*="placeholder"]').forEach((frame) => {
        this.frames.push({ frame, tip: tippy(frame, { content: this.card(brief), theme: 'light',
                                                      trigger: 'manual', interactive: true,
                                                      maxWidth: 320, appendTo: () => document.body }) })
      })
    })

    this.onMove = (event) => this.follow(event)
    this.element.addEventListener("mousemove", this.onMove)
    this.element.addEventListener("mouseleave", this.onMove)
  }

  disconnect() {
    this.element.removeEventListener("mousemove", this.onMove)
    this.element.removeEventListener("mouseleave", this.onMove)
    this.frames.forEach(({ tip }) => tip.destroy())
  }

  follow(event) {
    const under = this.frames.find(({ frame }) => this.covers(frame, event))

    this.frames.forEach(({ tip }) => {
      if (tip === under?.tip) return tip.show()
      if (!tip.popper.matches(":hover")) tip.hide()
    })
  }

  covers(frame, event) {
    if (!frame.closest("section")?.classList.contains("present")) return false

    const box = frame.getBoundingClientRect()
    return event.clientX >= box.left && event.clientX <= box.right &&
           event.clientY >= box.top && event.clientY <= box.bottom
  }

  slides() {
    return Array.from(this.element.querySelectorAll(".slides > section, .slides > div"))
  }

  card(brief) {
    const wrapper = document.createElement("div")
    wrapper.className = "flex flex-col gap-2 p-1 text-left"

    const text = document.createElement("p")
    text.className = "text-body"
    text.textContent = brief
    wrapper.appendChild(text)

    const button = document.createElement("button")
    button.type = "button"
    button.className = "self-start text-label underline"
    button.textContent = "Copy"
    button.addEventListener("click", () => {
      navigator.clipboard.writeText(brief).then(() => { button.textContent = "Copied" })
    })
    wrapper.appendChild(button)

    return wrapper
  }
}
